import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './config/msalConfig';
import Obituario from './Pages/Obituario';
import Servicos from './Pages/Servicos';
import Categoria from './Pages/Categoria';

const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/obituario" />} />
          <Route path="/obituario" element={<Obituario />} />
          <Route path="/servicos" element={<Servicos />} />
          <Route path="/fidelidade" element={<Categoria />} />
        </Routes>
      </Router>
    </MsalProvider>
  );
}

export default App;
